import type { Amenity, AmenityCategory } from '@interfaces/amenity.interface';

import { AMENITY_POOL } from '../pools';
import { pickN, randomBool, randomInt, uuid } from '../utils';

export function buildAmenity(name: string, icon: string, overrides?: Partial<Amenity>): Amenity {
  return {
    id: uuid(),
    name,
    description: `${name} available for guests`,
    highlighted: randomBool(0.3),
    selected: false,
    icon,
    active: true,
    ...overrides,
  };
}

export function buildAmenityCategory(
  key: string,
  pool: { names: string[]; icon: string },
  minItems = 3
): AmenityCategory {
  const count = randomInt(minItems, pool.names.length);
  const selectedNames = pickN(pool.names, count);
  return {
    key,
    name: key.charAt(0).toUpperCase() + key.slice(1),
    data: selectedNames.map(n => buildAmenity(n, pool.icon)),
  };
}

export function buildAllAmenityCategories(): AmenityCategory[] {
  return Object.entries(AMENITY_POOL).map(([key, pool]) => buildAmenityCategory(key, pool));
}
